import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import banner1 from "../../../assets/images/core.jpg";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SailingIcon from "@mui/icons-material/Sailing";
import PsychologyIcon from "@mui/icons-material/Psychology";
import WaterIcon from "@mui/icons-material/Water";
import FloodIcon from "@mui/icons-material/Flood";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GrassIcon from "@mui/icons-material/Grass";
import Container from "../../../common/Container";

const ColorButton2 = styled(Button)(() => ({
  color: "#fff",
  width: 180,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#9DCC49",
  borderColor: "#9DCC49",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#317ABE",
    borderColor: "#317ABE",
  },
}));

const list = [
  {
    icon: (
      <SailingIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    title: "Blue Economy Enhancement",
  },
  {
    icon: (
      <GrassIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    title: "Marine Flora & Fauna Protection Advocacy",
  },
  {
    icon: (
      <FloodIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    title: "Climate Resilience",
  },

  {
    icon: (
      <QueryStatsIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    title: "Research and Policy Innovation",
  },
  {
    icon: (
      <PsychologyIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    serial: "4",
    title: "Skilling-up Youths",
  },
  {
    icon: (
      <HandshakeIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
    serial: "5",
    title: "Downstream Partnerships",
  },
];

function CoreAreas() {
  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "15%", sm: "4%" }}>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Box position={"relative"}>
          <Box
            component="img"
            height={{ xs: "30vh", sm: "1000px" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              width: "100%",
            }}
            src={banner1}
            alt={"core-areas-image"}
          />
          <Container>
            <Box
              paddingBottom={"3%"}
              position={"absolute"}
              top={{ xs: "25%", sm: "12%" }}
              left={{ xs: "25%", sm: "0%" }}
              padding={{ xs: "5%", sm: "0% 5%" }}
              width={"100%"}
            >
              <Typography
                variant="h6"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                textAlign={"left"}
              >
                <Box component={"span"}>
                  <WaterIcon
                    sx={{
                      width: 23,
                      height: 23,
                    }}
                  />
                </Box>{" "}
                Core Areas
              </Typography>
              <Typography
                variant="h3"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                textAlign={"left"}
              >
                Empowering the Underserved Communities
              </Typography>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={{ xs: "100%", sm: "100%" }}
                flexWrap={"wrap"}
              >
                {list.map((lists, id) => (
                  <Box
                    key={id}
                    width={{ xs: "50%", sm: "33.3%" }}
                    marginTop={{ xs: "5%", sm: "1%" }}
                    padding={{ xs: "2%", sm: "3%" }}
                    data-aos={"fade-up"}
                    marginLeft={{ xs: "0%", sm: "0%" }}
                    display={"flex"}
                  >
                    <Box>
                      <Box marginTop={"1%"}>
                        <Avatar
                          sx={{
                            bgcolor: "rgba(0,0,0,0)",
                            border: " 2px dotted #fff",
                            color: "#9DCC49",
                            width: 76,
                            height: 76,
                          }}
                          variant="rounded"
                        >
                          {lists.icon}
                        </Avatar>
                      </Box>
                      <Box width={{ xs: "100%", sm: "60%" }}>
                        <Typography
                          variant={"h6"}
                          fontWeight={700}
                          textAlign={"center"}
                          paddingTop={"2%"}
                          color={"#fff"}
                        >
                          {lists.title}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
              <Box
                display={"flex"}
                justifyContent={"center"}
                marginTop={{ xs: "5%", sm: "2%" }}
              >
                <ColorButton2
                  component={"a"}
                  variant="contained"
                  size="medium"
                  href={"/our-core-areas"}
                >
                  Read More
                </ColorButton2>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default CoreAreas;
